import client from './client';

/**
 * Question Sets API
 * Backend: /api/question-sets  (Phase 1)
 */

export const listQuestionSets = (params = {}) =>
  client.get('/api/question-sets', { params });

export const getQuestionSet = (id) =>
  client.get(`/api/question-sets/${id}`);

export const createQuestionSet = (payload) =>
  client.post('/api/question-sets', payload);

export const updateQuestionSet = (id, payload) =>
  client.patch(`/api/question-sets/${id}`, payload);

export const deleteQuestionSet = (id) =>
  client.delete(`/api/question-sets/${id}`);
